import { Injectable, EventEmitter } from '@angular/core';

export interface ReportToast {
  report: string;
  type: 'success' | 'error' | 'info' | 'apierror' | 'nodataerror';
  dismissible?: boolean;
  errorCode?: string;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerReportingToastService {
  toasts: ReportToast[] = [];
  toastClick = new EventEmitter<ReportToast>();

  show(
    report: string = 'selected report',
    type: 'success' | 'error' | 'info' | 'apierror' | 'nodataerror' = 'error',
    duration?,
    dismissible = true,
    errorCode?: string,
  ) {
    const toast: ReportToast = { report, type, dismissible, errorCode };
    this.toasts.unshift(toast);

    if (duration > 0) {
      setTimeout(() => this.remove(toast), duration);
    }
  }

  remove(toast: ReportToast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  onToastClick(toast: ReportToast) {
    this.toastClick.emit(toast);
  }

  clearToasts() {
    this.toasts = [];
  }
}
